(function () {
  // Garde d'idempotence : la page "Aide & FAQ" inclut ce script depuis
  // plusieurs sections independantes (questions populaires + categories),
  // qui peuvent toutes deux etre presentes sur la meme page — sans ce
  // marqueur, un meme bouton recevrait 2 listeners et le clic togglerait
  // is-open deux fois de suite (ouverture puis fermeture immediate).
  document.querySelectorAll('.faq-item__question:not([data-faq-wired])').forEach(function (btn) {
    btn.setAttribute('data-faq-wired', '');
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var isOpen = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen);
    });
  });
})();
